import { Suspense } from 'react'
import { DatabaseSwitcherFallback } from '@/components/layout/breadcrumbs/database/database-switcher/fallback'
import { DatabaseSwitcherData } from '@/components/layout/breadcrumbs/database/database-switcher/switcher'

export const DatabaseSwitcher = () => (
  <Suspense fallback={<DatabaseSwitcherFallback />}>
    <DatabaseSwitcherData />
  </Suspense>
)
